var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconForEmployers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.007 3.36957C9.63938 3.36957 9.34106 3.07125 9.34106 2.70367V1.70483H6.67749V2.70367C6.67749 3.07125 6.37917 3.36957 6.0116 3.36957C5.64402 3.36957 5.3457 3.07125 5.3457 2.70367V1.70483C5.3457 0.970353 5.94301 0.373047 6.67749 0.373047H9.34106C10.0755 0.373047 10.6728 0.970353 10.6728 1.70483V2.70367C10.6728 3.07125 10.3745 3.36957 10.007 3.36957Z",
    fill: "#FFC700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48206 9.2811C8.3622 9.32771 8.18906 9.36101 8.00927 9.36101C7.82948 9.36101 7.65635 9.32771 7.49653 9.26778L0.0185547 6.77734V11.8581C0.0185547 12.8703 0.837603 13.6893 1.84976 13.6893H14.1688C15.1809 13.6893 16 12.8703 16 11.8581V6.77734L8.48206 9.2811Z",
    fill: "#FFC700"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.2023V5.72719L8.16909 8.3375C8.11582 8.35747 8.06254 8.36413 8.00927 8.36413C7.956 8.36413 7.90273 8.35747 7.84946 8.3375L0.0185547 5.72719V4.2023C0.0185547 3.19014 0.837603 2.37109 1.84976 2.37109H14.1688C15.1809 2.37109 16 3.19014 16 4.2023Z",
    fill: "#FFC700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconForEmployers);
export default __webpack_public_path__ + "static/media/icon-for-employers.9410e66b22f3a82e245a9fa10991f441.svg";
export { ForwardRef as ReactComponent };